import axios from "axios"


const MAX_REQUESTS_COUNT = 5
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0
let showRedirectWarning = false

const api = axios.create({
  baseURL: process.env.REACT_APP_API  
})


/**
 * Axios Request Interceptor
 */
api.interceptors.request.use(function(config) {
  return new Promise((resolve, reject) => {
    let interval = setInterval(() => {
      if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
        PENDING_REQUESTS++
        clearInterval(interval)
        resolve(config)
      }
    }, INTERVAL_MS)
  })
})

/**
 * Axios Response Interceptor
 */
api.interceptors.response.use(
  function(response) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.resolve(response)
  },
  function(error) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    if (typeof error.response === "undefined") {
      const location = window.location
      if (location && location.port === "3001") { // TODO why this?
        if (!showRedirectWarning) {
          showRedirectWarning = true
          alert(
            `You have been logged out or connection has been lost. You will be redirected to login page. Then you need to change your port to ${
              location.port
            }.`,
          )
          const targetUrl =
            location.protocol + "//" + location.hostname + ":8080"
          window.location.replace(targetUrl)
        }
      }
    }
    return Promise.reject(error)
  },
)

// interceptor missing
export const apiWithCredentials = axios.create({
    baseURL: process.env.REACT_APP_API,
    withCredentials: true,
  })

/**
 * Axios Request Interceptor
 */
apiWithCredentials.interceptors.request.use(function(config) {
    return new Promise((resolve, reject) => {
      let interval = setInterval(() => {
        if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
          PENDING_REQUESTS++
          clearInterval(interval)
          resolve(config)
        }
      }, INTERVAL_MS)
    })
  })
  
  /**
   * Axios Response Interceptor
   */
  apiWithCredentials.interceptors.response.use(
    function(response) {
      PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
      return Promise.resolve(response)
    },
    function(error) {
      PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
      if (typeof error.response === "undefined") {
        const location = window.location
        if (location && location.port === "3001") { // TODO why this?
          if (!showRedirectWarning) {
            showRedirectWarning = true
            alert(
              `You have been logged out or connection has been lost. You will be redirected to login page. Then you need to change your port to ${
                location.port
              }.`,
            )
            const targetUrl =
              location.protocol + "//" + location.hostname + ":8080"
            window.location.replace(targetUrl)
          }
        }
      }
      return Promise.reject(error)
    },
  )






export default api
